var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOvertime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.85,
    height: 19.85,
    viewBox: "0 0 19.85 19.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "info_FILL1_wght400_GRAD0_opsz48",
    d: "M14,18.887a.721.721,0,0,0,.744-.744V13.652a.674.674,0,0,0-.223-.509A.735.735,0,0,0,14,12.932a.721.721,0,0,0-.744.744v4.491a.674.674,0,0,0,.223.509A.735.735,0,0,0,14,18.887ZM13.925,11.1a.815.815,0,0,0,.583-.223.752.752,0,0,0,.236-.571.834.834,0,0,0-.236-.6.809.809,0,0,0-1.166,0,.834.834,0,0,0-.236.6.752.752,0,0,0,.236.571.815.815,0,0,0,.583.223Zm0,12.753A10.066,10.066,0,0,1,10,23.093a9.606,9.606,0,0,1-5.248-5.248A10.066,10.066,0,0,1,4,13.925a10,10,0,0,1,.757-3.9,9.686,9.686,0,0,1,2.1-3.151A9.895,9.895,0,0,1,13.925,4a9.845,9.845,0,0,1,9.925,9.925A9.895,9.895,0,0,1,20.971,21a9.686,9.686,0,0,1-3.151,2.1A10,10,0,0,1,13.925,23.85Z",
    transform: "translate(-4 -4)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOvertime);
export default __webpack_public_path__ + "static/media/info_overtime.aaececdd2f02fb0d4b7972751b722904.svg";
export { ForwardRef as ReactComponent };